module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container section"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.leadCarrierLocationProducts), function(l, i) {
    return _c('div', {
      staticClass: "row lined"
    }, [_c('div', {
      staticClass: "col-12 carrier-location"
    }, [_c('strong', [_vm._v(_vm._s(l.location.formatted_address))])]), _vm._v(" "), (l.carrierProducts.length) ? _c('div', {
      staticClass: "container carrier-product-container "
    }, _vm._l((l.carrierProducts), function(p) {
      return _c('div', {
        staticClass: "row lined"
      }, [_c('div', {
        staticClass: "col-6"
      }, [_c('strong', [_vm._v(_vm._s(p.carrierProductName))]), _c('br'), _vm._v("\n                        " + _vm._s(p.carrierProductAccess) + "/" + _vm._s(p.carrierProductCriteria) + "\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "col-2"
      }, [_c('strong', [_vm._v("QTY: ")]), _vm._v(_vm._s(p.qty)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("TERM: ")]), _vm._v(_vm._s(p.term)), _c('br')]), _vm._v(" "), _c('div', {
        staticClass: "col-2"
      }, [_c('strong', [_vm._v("MRC: ")]), _vm._v(_vm._s(p.mrc)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("NRC: ")]), _vm._v(_vm._s(p.nrc)), _c('br')]), _vm._v(" "), _c('div', {
        staticClass: "col-2 text-right"
      }, [_c('dropdown-confirmation', {
        on: {
          "confirm": function($event) {
            _vm.deleteProduct(p)
          }
        }
      })], 1)])
    })) : _c('div', {
      staticClass: "container "
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('em', {
      staticClass: "subdued"
    }, [_vm._v("There are no products quoted")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.createQuote = true
      }
    }
  }, [_vm._v("Create Quote")])])]), _vm._v(" "), (_vm.createQuote) ? _c('modal', {
    attrs: {
      "allow-click-away": "false",
      "size": "xl"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h3', {
    staticClass: "modal-title d-inline d-flex justify-content-start"
  }, [_vm._v("Create Quote")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetQuote
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('quote', {
    attrs: {
      "details": _vm.details,
      "carrier": _vm.activeCarrier
    },
    on: {
      "close": function($event) {
        _vm.createQuote = false
      },
      "refetch": _vm.getQuoteData
    }
  })], 1)]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row heading"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Quotes")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10ac6aa7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/LeadQuotes.vue
// module id = 356
// module chunks = 0